var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 0H3a3 3 0 0 0-3 3v30a3 3 0 0 0 3 3h30a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3z",
    fill: "#5f00a0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.239 15.85v-2.136H10.52v2.137H23.24zm0 3.18v-2.136H10.52v2.136H23.24zm0 3.18v-2.137H10.52v2.137H23.24zm4.222-10.632v19.076l-4.222-4.222H8.385a1.97 1.97 0 0 1-1.476-.636 2.095 2.095 0 0 1-.61-1.5V11.577c0-.577.203-1.068.61-1.475a2.01 2.01 0 0 1 1.476-.61h16.99a2.01 2.01 0 0 1 1.475.61c.407.407.61.898.61 1.475zM30.13 4.438v2.268h2.268v1.107H30.13v2.268h-1.107V7.813h-2.268V6.706h2.268V4.437h1.107z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.c25a178ffa727108be8eb25f73ce9062.svg";
export { ForwardRef as ReactComponent };